import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

const st1 = 'font-weight: bold; color: darkorange'
const st2 = 'font-weight: bold; color: green'
const st3 = 'font-weight: bold; color: purple'

@Injectable()
export class SsrService {
  private data = new Map()
  isRehydratedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  constructor() {}

  wait(name: string) {
    // console.log('%c Wait: ', st1, name);
    this.data.set(name, { isReady: false })
  }

  ready(name: string) {
    if (!this.data.has(name)) {
      return
    }

    // console.log('%c Ready: ', st2, name);
    this.data.set(name, { isReady: true })
    if (this.isCommonReady()) {
      this.reHydration()
    }
  }

  isCommonReady() {
    let isReadyCount = 0
    this.data.forEach(value => {
      if (!!value.isReady) {
        isReadyCount = isReadyCount + 1
      }
    })
    // console.log(' Common size: ', this.data.size, 'isReadyCount: ', isReadyCount);

    return this.data.size === isReadyCount
  }

  reHydration() {
    if (this.isRehydratedSubject.getValue()) {
      // console.log('%c Already rehydrated', st3);
      return
    }

    // console.log('%c Rehydration', st3);
    const ssrContentEl = document.querySelector('#ssr-content') as HTMLElement
    const appRootEl = document.querySelector('#app-root') as HTMLElement

    if (ssrContentEl) {
      ssrContentEl.style.display = 'none'
    }
    if (appRootEl) {
      appRootEl.style.display = 'block'
    }
    this.isRehydratedSubject.next(true)
  }
}
